/**
 * Derive the data-sign value for an inline model quantity. Opt-in only
 * (color-by-sign), and zero is neutral (returns undefined → no attribute,
 * so the value inherits the default text color). Kept dependency-free so it
 * can be unit-tested without pulling in the tiptap node view.
 */
export function signForValue(
    numericalValue: unknown,
    colorBySign: boolean,
): "positive" | "negative" | undefined {
    if (!colorBySign || typeof numericalValue !== "number") return undefined;
    if (numericalValue > 0) return "positive";
    if (numericalValue < 0) return "negative";
    return undefined;
}
